(() => {
  // Hide immediately if cart is empty (check as soon as script loads to prevent flash)
  function hideIfEmptyCart() {
    const stickyEl = document.getElementById('al-sticky-cart-checkout');
    const cartPage = document.querySelector('.cart-page');
    if (stickyEl && cartPage && cartPage.classList.contains('cart-page--empty')) {
      stickyEl.style.display = 'none';
      return true;
    }
    return false;
  }

  // Check immediately if elements already exist
  if (hideIfEmptyCart()) return;

  /**
   * @param {() => void} callback
   */
  function onReady(callback) {
    if (document.readyState === 'loading') {
      // Check repeatedly while DOM is loading to catch empty cart early
      const checkEmpty = () => {
        if (hideIfEmptyCart()) return;
        if (document.readyState !== 'loading') {
          callback();
        } else {
          requestAnimationFrame(checkEmpty);
        }
      };
      requestAnimationFrame(checkEmpty);
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      if (hideIfEmptyCart()) return;
      callback();
    }
  }

  onReady(() => {
    const stickyEl = document.getElementById('al-sticky-cart-checkout');
    const cartPage = document.querySelector('.cart-page');
    const ctasEl = document.querySelector('.cart__ctas');

    // Check if cart is empty - if so, don't show sticky checkout
    if (cartPage && cartPage.classList.contains('cart-page--empty')) {
      if (stickyEl) stickyEl.style.display = 'none';
      return;
    }

    if (!stickyEl || !ctasEl) return;

    // Preserve initial display so we can restore it when showing
    const computed = window.getComputedStyle(stickyEl);
    const initialDisplay = computed.display === 'none' ? '' : computed.display;

    let isCtasInView = true;
    let isScrollingDown = false;
    let lastScrollY = window.scrollY;
    /** @type {number | null} */
    let rafId = null;

    /**
     * @param {boolean} visible
     */
    const setVisible = (visible) => {
      // Show when visible, hide when not
      if (visible) {
        stickyEl.style.display = initialDisplay;
      } else {
        stickyEl.style.display = 'none';
      }
    };

    const update = () => {
      rafId = null;
      const shouldShow = isScrollingDown && !isCtasInView;
      setVisible(shouldShow);
    };

    const requestUpdate = () => {
      if (rafId == null) rafId = requestAnimationFrame(update);
    };

    // Track scroll direction
    const onScroll = () => {
      const currentY = window.scrollY;
      isScrollingDown = currentY > lastScrollY;
      lastScrollY = currentY;
      requestUpdate();
    };

    // Observe CTA visibility
    const io = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.target === ctasEl) {
            isCtasInView = entry.isIntersecting && entry.intersectionRatio > 0;
            requestUpdate();
          }
        }
      },
      {
        root: null,
        threshold: [0, 0.01, 0.99, 1],
      }
    );

    io.observe(ctasEl);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', requestUpdate);

    // Initial state
    setVisible(false);
    requestUpdate();

    // Safety: disconnect on page hide
    window.addEventListener(
      'pagehide',
      () => {
        io.disconnect();
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', requestUpdate);
        if (rafId != null) cancelAnimationFrame(rafId);
      },
      { once: true }
    );
  });
})();


